const dataUpload = {
  state: {
    beginUpdate: new Date()
  },
  mutations: {
    set_dataUpload_update (state, data) {
      state.beginUpdate = data
    }
  },
  getters: {

  },
  actions: {

  }
}

export default dataUpload
